// Entry point for React app (renamed for Vite JSX compatibility)
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { toast } from "react-toastify";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppContextProvider } from "./context/app-context";
import "@progress/kendo-theme-material/dist/all.css";
import "./index.scss";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const message =
        error.response?.data?.message ||
        "You do not have permission to perform this action.";
      toast.error(message, { toastId: "forbidden-error" });
    }
    return Promise.reject(error);
  }
);
// import '@progress/kendo-theme-default/dist/all.css';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppContextProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AppContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
